import React from "react";

// Brand-safe gradient panels — used everywhere instead of stock photos.
// No third-party imagery = zero brand risk.

const GRADIENTS = {
  navy: "bg-gradient-to-br from-[#0A192F] via-[#132a4a] to-[#1e3a6f]",
  blue: "bg-gradient-to-br from-[#1E40AF] via-[#2563EB] to-[#3B82F6]",
  slate: "bg-gradient-to-br from-[#0F172A] via-[#1E293B] to-[#334155]",
  ocean: "bg-gradient-to-br from-[#0A192F] via-[#0F3A5F] to-[#2563EB]",
  midnight: "bg-gradient-to-br from-[#020617] via-[#0A192F] to-[#1E3A8A]",
  royal: "bg-gradient-to-br from-[#1E3A8A] via-[#2563EB] to-[#60A5FA]",
};

// Deterministic gradient picker so the same key always renders the same colour.
const pick = (key) => {
  const keys = Object.keys(GRADIENTS);
  const hash = String(key || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return GRADIENTS[keys[hash % keys.length]];
};

export const MediaPanel = ({ variant, icon: Icon, label, height = "h-[420px]", className = "" }) => (
  <div className={`relative overflow-hidden rounded-[2rem] ${pick(variant)} ${height} ${className}`}>
    {/* Dot grid overlay */}
    <div
      className="absolute inset-0 opacity-[0.08]"
      aria-hidden
      style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
        backgroundSize: "28px 28px",
      }}
    />
    {/* Soft blob for depth */}
    <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full bg-white/10 blur-3xl" aria-hidden />
    <div className="absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-black/20 blur-3xl" aria-hidden />

    <div className="relative h-full w-full p-8 flex flex-col justify-between">
      {Icon && (
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 text-white">
          <Icon className="h-6 w-6" strokeWidth={1.5} />
        </div>
      )}
      {label && (
        <div>
          <div className="text-white/60 text-xs tracking-[0.24em] uppercase font-bold">BoxB Solutions</div>
          <div className="mt-1 font-display font-semibold text-2xl text-white">{label}</div>
        </div>
      )}
    </div>
  </div>
);

export const MediaThumb = ({ variant, icon: Icon }) => (
  <div className={`relative overflow-hidden rounded-2xl ${pick(variant)} h-40 border border-white/10`}>
    <div
      className="absolute inset-0 opacity-[0.1]"
      aria-hidden
      style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
        backgroundSize: "24px 24px",
      }}
    />
    <div className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-white/10 blur-2xl" aria-hidden />
    {Icon && (
      <div className="relative h-full w-full flex items-center justify-center">
        <Icon className="h-14 w-14 text-white/90" strokeWidth={1.25} />
      </div>
    )}
  </div>
);
